import { PrayersFooterStrip } from '../funnel/PrayersPlacements';
import { WhyCFRBand } from '../WhyCFRBand';
import Logo from '../Logo';
import { COLORS } from './landingData';

const LandingFooter = () => {
  return (
    <>
    <WhyCFRBand />
    <PrayersFooterStrip />
    <footer style={{ padding: '3rem 0', background: COLORS.white, borderTop: `1px solid ${COLORS.sage}20` }}>
      <div className="container mx-auto px-6">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '2rem 1.5rem', textAlign: 'left' }}>
          <div style={{ gridColumn: '1 / -1' }} className="footer-brand">
            <Logo />
            <p style={{ marginTop: '0.75rem', color: `${COLORS.navy}99`, fontSize: '0.9375rem', textAlign: 'left', padding: 0, margin: '0.75rem 0 0', maxWidth: '100%' }}>
              Faith-based recovery support, 24/7
            </p>
          </div>
          {[
            ['Product', [['/what-we-offer', 'What We Offer'], ['/pricing', 'Pricing'], ['/for-organizations', 'For Churches & Centres'], ['/safeguarding', 'Safeguarding & due diligence'], ['/seven-prayers', 'Free: Seven Prayers']]],
            ['About', [['/founder-story', 'Our Story'], ['/what-we-believe', 'What We Believe'], ['/contact', 'Contact'], ['/faq', 'FAQ']]],
            ['Legal', [['/terms', 'Terms'], ['/privacy', 'Privacy']]],
          ].map(([heading, links]) => (
            <div key={heading}>
              <h4 style={{ fontWeight: 700, color: COLORS.navy, marginBottom: '0.75rem', fontSize: '0.8125rem', letterSpacing: '1.5px', textTransform: 'uppercase', textAlign: 'left', padding: 0 }}>{heading}</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: '0.5rem' }}>
                {links.map(([href, label]) => (
                  <li key={href} style={{ margin: 0, lineHeight: 1.4 }}><a href={href} data-testid={{ '/what-we-believe': 'footer-what-we-believe-link', '/safeguarding': 'footer-safeguarding-link', '/what-we-offer': 'footer-what-we-offer-link' }[href]} style={{ color: `${COLORS.navy}CC`, fontSize: '0.9375rem', textDecoration: 'none' }}>{label}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <style>{`@media (min-width: 768px){ .footer-grid{ grid-template-columns: 1.5fr 1fr 1fr 1fr !important; } .footer-brand{ grid-column: auto !important; } }`}</style>

        <div data-testid="footer-crisis-strip" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.5rem 1.25rem', background: '#F7C4C4', border: '2px solid #991B1B', borderRadius: '12px', padding: '0.85rem 1.25rem', marginTop: '2rem', boxShadow: '0 2px 12px rgba(153,27,27,0.2)' }}>
          <span style={{ color: '#991B1B', fontWeight: 800, fontSize: '0.95rem' }}>In crisis right now?</span>
          <a href="/crisis" style={{ color: '#991B1B', fontWeight: 700, textDecoration: 'underline', fontSize: '0.95rem' }}>Get Help Now →</a>
        </div>

        {/* Trust Badges / Certifications */}
        <div style={{ 
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: `1px solid ${COLORS.sage}20`
        }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2.5rem',
            marginBottom: '2rem'
          }}>
            {/* Security Badge */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 1.25rem',
              background: `${COLORS.sage}10`,
              borderRadius: '0.5rem',
              border: `1px solid ${COLORS.sage}30`
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                background: COLORS.sage,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: COLORS.white,
                fontSize: '1.25rem'
              }}>
                🔒
              </div>
              <div>
                <div style={{ fontWeight: 700, color: COLORS.navy, fontSize: '0.875rem' }}>
                  256-bit Encryption
                </div>
                <div style={{ fontSize: '0.75rem', color: `${COLORS.navy}99` }}>
                  Your data is secure
                </div>
              </div>
            </div>

            {/* Privacy Protected */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 1.25rem',
              background: `${COLORS.navy}10`,
              borderRadius: '0.5rem',
              border: `1px solid ${COLORS.navy}30`
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                background: COLORS.navy,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: COLORS.white,
                fontSize: '1.25rem'
              }}>
                🛡️
              </div>
              <div>
                <div style={{ fontWeight: 700, color: COLORS.navy, fontSize: '0.875rem' }}>
                  Privacy Protected
                </div>
                <div style={{ fontSize: '0.75rem', color: `${COLORS.navy}99` }}>
                  Confidential, never shared
                </div>
              </div>
            </div>

            {/* Stripe Verified */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 1.25rem',
              background: `${COLORS.rust}10`,
              borderRadius: '0.5rem',
              border: `1px solid ${COLORS.rust}30`
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                background: COLORS.rust,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: COLORS.white,
                fontSize: '1.25rem'
              }}>
                ✓
              </div>
              <div>
                <div style={{ fontWeight: 700, color: COLORS.navy, fontSize: '0.875rem' }}>
                  Stripe Verified
                </div>
                <div style={{ fontSize: '0.75rem', color: `${COLORS.navy}99` }}>
                  Secure payments
                </div>
              </div>
            </div>

            {/* Faith-Based Ministry */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.75rem 1.25rem',
              background: `linear-gradient(135deg, ${COLORS.sage}15, ${COLORS.rust}10)`,
              borderRadius: '0.5rem',
              border: `2px solid ${COLORS.sage}40`
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                background: `linear-gradient(135deg, ${COLORS.sage}, ${COLORS.rust})`,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: COLORS.white,
                fontSize: '1.25rem'
              }}>
                ✝️
              </div>
              <div>
                <div style={{ fontWeight: 700, color: COLORS.navy, fontSize: '0.875rem' }}>
                  Faith-Based Ministry
                </div>
                <div style={{ fontSize: '0.75rem', color: `${COLORS.navy}99` }}>
                  Christ-centered recovery
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ 
          paddingTop: '2rem',
          borderTop: `1px solid ${COLORS.sage}20`,
          textAlign: 'center',
          color: `${COLORS.navy}99`,
          fontSize: '0.875rem'
        }}>
          © {new Date().getFullYear()} Christian Family Recovery. All rights reserved.
          <div>
            <a href="/admin/dashboard" data-testid="footer-team-portal-link" style={{
              display: 'inline-block',
              marginTop: '0.75rem',
              color: `${COLORS.navy}55`,
              fontSize: '0.75rem',
              textDecoration: 'none'
            }}>
              Team Portal
            </a>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default LandingFooter;
